import utilities from '@/helpers/utilities';

export default {
    build() {
        return {
            id: null,
            name: '',
            description: '',
            isActive: true,
            isInUse: false,
            steps: [],
        };
    },

    toForm(obj) {
        const clone = utilities.toForm(obj, this.build());

        // 8 = NO APPROVER
        clone.steps = clone.steps.filter(step => step.approverType.officeId !== 0);

        return clone;
    },

    toPayload(obj) {
        const clone = utilities.toPayload(obj);
        // if (clone.isInUse) clone.steps = null;

        return clone;
    },

    step: {
        build(status) {
            return {
                id: 0,
                status: { id: status },
                approverType: { id: 0, officeId: 0 },
                costThreshold: '',
                uuid: utilities.uuidv4(),
            };
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/DemandType.js